import { ProgramWorkbookDownload } from "./ProgramWorkbookDownload";
import { WorkbookData } from "@platform/types/dashboard.types";
import { usePlatform } from "@platform/PlatformContext";

export function ProgramWorkbookDownloadContainer() {
  const data = {
    file: {
      name: "Pollinator Workbook: Fall 2025 Cycle",
      type: "PDF",
      size: "",
      downloadUrl:
        "https://pollinator-production.s3.us-east-1.amazonaws.com/production/assets/materials/PollinatorWorkbookFall2025Cycle.pdf",
    },
    caption: {
      text: "Pollinator Workbook: Fall 2025 Cycle",
    },
  } as WorkbookData;

  const { isWorkbookDownloadDisabled } = usePlatform();

  if (isWorkbookDownloadDisabled) {
    return null;
  }

  return <ProgramWorkbookDownload data={data} />;
}

export default ProgramWorkbookDownloadContainer;
